import React from "react";
import ProfileImage from "../profileImage";

const NotificationItem = ({ notification }) => {

  const formatDate = (dateString) => {
    try {
      const date = new Date(dateString);
      const now = new Date();
      const diffInHours = (now - date) / (1000 * 60 * 60);
      
      if (diffInHours < 1) {
        const diffInMinutes = Math.floor((now - date) / (1000 * 60));
        return `${diffInMinutes}m ago`;
      } else if (diffInHours < 24) {
        return `${Math.floor(diffInHours)}h ago`;
      } else {
        return date.toLocaleDateString("en-US", {
          month: "short",
          day: "numeric",
          year: date.getFullYear() !== now.getFullYear() ? "numeric" : undefined,
        });
      }
    } catch (error) {
      return dateString;
    }
  };

  return (
    <div
      className={`p-6 hover:bg-gray-50 transition-colors duration-200 flex items-start space-x-4 ${
        !notification.read ? "bg-blue-50 border-l-4 border-l-blue-500" : ""
      }`}
    >
      {/* Avatar/Icon */}
      <div className="flex-shrink-0">
        {notification.image ? (
          <ProfileImage
            image={notification.image}
            className="h-12 w-12 rounded-full object-cover ring-2 ring-gray-200"
            alt="Notification"
          />
        ) : (
          <div className="h-12 w-12 rounded-full bg-gradient-to-br from-blue-400 to-blue-600 flex items-center justify-center">
            <svg
              className="h-6 w-6 text-white"
              fill="none"
              viewBox="0 0 24 24"
              stroke="currentColor"
            >
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth={2}
                d="M15 17h5l-1.405-1.405A2.032 2.032 0 0118 14.158V11a6.002 6.002 0 00-4-5.659V5a2 2 0 10-4 0v.341C7.67 6.165 6 8.388 6 11v3.159c0 .538-.214 1.055-.595 1.436L4 17h5m6 0v1a3 3 0 11-6 0v-1m6 0H9"
              />
            </svg>
          </div>
        )}
      </div>

      {/* Content */}
      <div className="flex-1 min-w-0">
        <p
          className={`text-sm leading-relaxed ${
            !notification.read ? "font-semibold text-gray-900" : "text-gray-700"
          }`}
        >
          {notification.message}
        </p>
        <div className="flex items-center justify-between mt-2">
          <p className="text-xs text-gray-500">
            {formatDate(notification.createdAt)}
          </p>
          {!notification.read && (
            <div className="flex items-center space-x-1 text-blue-600">
              <div className="h-2 w-2 rounded-full bg-blue-600"></div>
              <span className="text-xs font-medium">New</span>
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default NotificationItem; 